import { useState, useEffect } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import IosShareIcon from '@mui/icons-material/IosShare';

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [promptType, setPromptType] = useState(null); // 'android' or 'ios'

  useEffect(() => {
    // Check if user dismissed before
    const dismissedAt = localStorage.getItem('installPromptDismissed');
    const daysSinceDismissed = dismissedAt
      ? (Date.now() - parseInt(dismissedAt)) / (1000 * 60 * 60 * 24)
      : 999;

    // Don't show if dismissed within last 7 days
    if (daysSinceDismissed < 7) return;

    const isAndroid = /Android/i.test(navigator.userAgent);

    // iOS detection
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;

    if (isIOS && !isInStandaloneMode) {
      // Show iOS install prompt after 2 seconds
      setTimeout(() => {
        setPromptType('ios');
        setShowPrompt(true);
      }, 2000);
      return;
    }

    if (!isAndroid) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show prompt after 2 seconds
      setTimeout(() => {
        setPromptType('android');
        setShowPrompt(true);
      }, 2000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (promptType === 'ios') {
      // iOS doesn't support programmatic install, just dismiss
      setShowPrompt(false);
      return;
    }

    if (!deferredPrompt) {
      alert('יש להתקין ידנית: תפריט → הוסף למסך הבית');
      setShowPrompt(false);
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'dismissed') {
      localStorage.setItem('installPromptDismissed', Date.now().toString());
    } else {
      localStorage.removeItem('installPromptDismissed');
    }

    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleClose = () => {
    localStorage.setItem('installPromptDismissed', Date.now().toString());
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  const isIOS = promptType === 'ios';

  return (
    <Snackbar
      open={showPrompt}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: 80 }}
    >
      <Alert
        severity="info"
        onClose={handleClose}
        icon={isIOS ? <IosShareIcon /> : <DownloadIcon />}
        action={
          isIOS ? null : (
            <Button color="inherit" size="small" onClick={handleInstall}>
              התקן
            </Button>
          )
        }
        sx={{ width: '100%' }}
      >
        {isIOS
          ? 'להתקנה: לחץ על שיתוף ← הוסף למסך הבית'
          : 'התקן את BalancePro לגישה מהירה!'}
      </Alert>
    </Snackbar>
  );
}

export default InstallPrompt;
